<footer>
  <p class="footerText">
    Valokuvat Kansalliskirjaston FINNA-palvelusta (CC BY 4.0).
  </p>
</footer>

<style>
  footer {
    text-align: center;
    padding: 1rem;
  }

  .footerText {
    display: inline-block;
    padding-top: 1rem;
    border-top: 1px solid rgb(83, 82, 82);
  }
</style>
